import { BaseAccount } from 'modules/Account';
import { FieldName, FormValidationResult, FormValues } from 'types/form';

export type BaseDeveloper = {
  name: string;
  email: string;
};

export type JWTRealmAccess = {
  roles: string[];
};

export type DeveloperDetails = BaseDeveloper & {
  id: string;
  photo?: string;
};

export type Developer = DeveloperDetails & {
  realm_access: JWTRealmAccess;
  role: AccountRoles;
  accountId: string;
};

export const AccountRole = {
  OWNER: 'OWNER',
  USER: 'USER',
} as const;

export type AccountRoles = keyof typeof AccountRole;

export type DeveloperAccount = {
  id: string;
  role: AccountRoles;
};

export type GetDeveloperResponse = {
  developer: DeveloperDetails;
  teams: DeveloperAccount[];
};

export type NewDeveloper = {
  acceptTerms: boolean;
  developer: BaseDeveloper;
  team: BaseAccount;
  password: string;
};

export const UpdateDeveloperFormFields = {
  name: 'name' as FieldName<string>,
  photo: 'photo' as FieldName<File | string>,
};

export type UpdateDeveloperFormValues = FormValues<typeof UpdateDeveloperFormFields>;
export type UpdateDeveloperFormValidationResult = FormValidationResult<typeof UpdateDeveloperFormFields>;
export type UpdateDeveloperFormValidated = Required<Omit<UpdateDeveloperFormValues, 'photo'>> &
  Pick<UpdateDeveloperFormValues, 'photo'>;

export type DeveloperUpdate = UpdateDeveloperFormValidated;

export const InviteStatus = {
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
} as const;

export type InviteStatuses = keyof typeof InviteStatus;

export type Invite = {
  team: {
    personType: string;
    identification: string;
    name: string;
    phone: string;
    country: string;
    slug: string;
  };
  developer: {
    email: string;
  };
  status: InviteStatuses;
  expired: false;
};
